<app-slim-topbar></app-slim-topbar>
<div class="layout-content p-0 mb-5 mt-3" [ngClass]="layoutMarginResponsive()">
	<div class="flex align-items-center justify-content-center w-full font-semibold text-2xl my-5">{{'FIRMWARE_LIST' | translate}}</div>
	<div class="grid mt-0 pb-1" [style]="overTablet() ? 'margin-bottom: 14rem;' : ''">
		<div class="col-12" [ngClass]="customPaddingX()">
			<div class="card border-round px-0">
				<!-- PLX IP 3.0.10 -->
				<!-- <div class="col-12">
					<div class="flex justify-content-center text-xl font-semibold">CAME PLX IP 3.0.10</div>
				</div> -->
				<div class="col-12" [ngClass]="customPaddingX()">
					<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">CAME PLX IP 3.0.10</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-button id="downloadFwPlx3010" label="{{ 'DOWNLOAD_FW' | translate }}" (click)="downloadPlxIp3010()"
								icon="pi cm-download"
								[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
							</p-button>
						</div>
					</div>
				</div>
				<div class="col-12" [ngClass]="customPaddingX()">
					<p-accordion>
						<p-accordionTab>
							<ng-template pTemplate="header">
								<div class="flex align-items-center w-full"
									[class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
									<div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">CAME PLX IP 3.0.10 | {{'RELEASE_NOTE' | translate}}</div>
								</div>
							</ng-template>
							<div [innerHTML]="getReleaseNotePlx3010()"></div>
						</p-accordionTab>
					</p-accordion>
				</div>
			</div>
		</div>
		<div class="col-12" [ngClass]="customPaddingX()">
			<div class="card border-round px-0">
				<!-- XTS 7 IP WiFi 7.0.3 -->
				<!-- <div class="col-12">
					<div class="flex justify-content-center text-xl font-semibold">CAME XTS 7 IP WiFi 7.0.3</div>
				</div> -->
				<div class="col-12" [ngClass]="customPaddingX()">
					<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">CAME XTS 7 IP WiFi 7.0.3</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-button id="downloadFwXts7Wifi703" label="{{ 'DOWNLOAD_FW' | translate }}" (click)="downloadXTS7IPWiFi703()"
								icon="pi cm-download"
								[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
							</p-button>
						</div>
					</div>
				</div>
				<div class="col-12" [ngClass]="customPaddingX()">
					<p-accordion>
						<p-accordionTab>
							<ng-template pTemplate="header">
								<div class="flex align-items-center w-full"
									[class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
									<div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">CAME XTS 7 IP WiFi 7.0.3 | {{'RELEASE_NOTE' | translate}}</div>
								</div>
							</ng-template>
							<div [innerHTML]="getReleaseNoteXTS7IPWiFi703()"></div>
						</p-accordionTab>
					</p-accordion>
				</div>
			</div>
		</div>
		<div class="col-12" [ngClass]="customPaddingX()">
			<div class="card border-round px-0">
				<!-- XTS 7 IP WiFi 7.0.3-V2 -->
				<!-- <div class="col-12">
					<div class="flex justify-content-center text-xl font-semibold">CAME XTS 7 IP WiFi 7.0.3-V2</div>
				</div> -->
				<div class="col-12" [ngClass]="customPaddingX()">
					<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">CAME XTS 7 IP WiFi 7.0.3-V2</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-button id="downloadFwXts7Wifi703V2" label="{{ 'DOWNLOAD_FW' | translate }}" (click)="downloadXTS7IPWiFi703V2()"
								icon="pi cm-download"
								[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
							</p-button>
						</div>
					</div>
				</div>
				<div class="col-12" [ngClass]="customPaddingX()">
					<p-accordion>
						<p-accordionTab>
							<ng-template pTemplate="header">
								<div class="flex align-items-center w-full"
									[class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
									<div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">CAME XTS 7 IP WiFi 7.0.3 | {{'RELEASE_NOTE' | translate}}</div>
								</div>
							</ng-template>
							<div [innerHTML]="getReleaseNoteXTS7IPWiFi703()"></div>
						</p-accordionTab>
					</p-accordion>
				</div>
			</div>
		</div>
	</div>
</div>
<app-common-footer></app-common-footer>